import React, {Fragment} from 'react'
import classNames from 'classnames'
import style from '../scss/components/CTAMessage.module.scss'
import styleMain from '../scss/Main.module.scss'
import Quote from './Quote'
import { Fade } from "react-awesome-reveal"
import {useSelector} from 'react-redux'
import speakerImg from '../assets/speaker-image.png'
import speakerImg2x from '../assets/speaker-image@2x.png'
import speakerImg3x from '../assets/speaker-image@3x.png'

const CTAMessage = () => {
    // @ts-ignore
    const width = useSelector(state => state.window.width)

    const imageColumn = () => {
        return (
            <div className={style.LeftColumn}>
                <img src={speakerImg}
                     srcSet={`${speakerImg2x} 2x, ${speakerImg3x} 3x`}
                     alt={'Kristo Olli - SalonLife\'i müügijuht, koolitaja, copywriter & ilusalongide konsultant'}/>
                {width < 950 ? (
                    <Fragment>
                        <strong>Kristo Olli</strong>
                        <p>SalonLife'i müügijuht, koolitaja, copywriter & ilusalongide konsultant</p>
                    </Fragment>
                ) : null}
            </div>
        )
    }

    return (
        <Fade direction={'down'} triggerOnce={true}>
            <div className={classNames(styleMain.Container, style.Container)}>
                <div className={style.Row}>
                    {width > 950 ? imageColumn() : null}
                    <div className={style.RightColumn}>
                        <h2>
                            Enam kui <strong>2000</strong> ilusalongiga koostöös avastatud parimad praktikad ja strateegiad jõuavad Sinuni <strong>4-osalise</strong> väärtusliku ja rohkete boonustega veebikursusena.
                        </h2>
                        {width > 950 ? <Quote title={'Kristo Olli'} hasMaxWidth={true} animated={false}>
                            SalonLife'i müügijuht, koolitaja, copywriter & ilusalongide konsultant
                        </Quote> : null}
                    </div>
                    {width < 950 ? imageColumn() : null}
                </div>
            </div>
        </Fade>
    )
}

export default CTAMessage
